var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.776,
    height: 17.241,
    viewBox: "0 0 28.776 17.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-address-card",
    "data-name": "Icon awesome-address-card",
    d: "M9.248,5.595A4.01,4.01,0,1,1,5.238,9.6,4.014,4.014,0,0,1,9.248,5.595Zm7.018,14.838a1.314,1.314,0,0,1-1.4,1.2H3.633a1.314,1.314,0,0,1-1.4-1.2v-1.2c0-1.993,1.886-3.609,4.211-3.609h.313a6.454,6.454,0,0,0,4.988,0h.313c2.325,0,4.211,1.617,4.211,3.609ZM29.8,17.625h0Zm0-4.01h0Zm0-4.01h0Z",
    transform: "translate(-1.63 -4.995)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.f319441ba360f9e12e92e17f244ff7a1.svg";
export { ForwardRef as ReactComponent };